import { ArrowRight, Zap } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <div className="cta-section">
      <div className="cta-in">
        <div>
          <div className="cta-h">
            Ready to read the report<br />that <em>holds itself accountable?</em>
          </div>
          <div className="cta-sub">
            Free to register and read. Pro unlocks projection ranges, bull &amp; bear cases, Devil's Advocate,
            watchlist, and daily audio briefing — $14.95 / month or $129 / year.
          </div>
        </div>
        <div className="cta-buttons">
          <Link to="/register?plan=annual" className="btn-cta">
            <Zap size={16} /> Start Pro Annual — $129/yr
          </Link>
          <Link to="/register?plan=free" className="btn-ghost-txt">
            Start reading free <ArrowRight size={14} />
          </Link>
        </div>
      </div>
    </div>
  );
}
